import { render, staticRenderFns } from "./CloFooterSocial.vue?vue&type=template&id=02348928&"
import script from "./CloFooterSocial.vue?vue&type=script&lang=js&"
export * from "./CloFooterSocial.vue?vue&type=script&lang=js&"
import style0 from "./CloFooterSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports